import React from 'react';
import { stats } from '../data/content';
export function Stats() {
  return <section className="w-full bg-cream px-4 py-10 sm:py-12" aria-label="Key numbers" data-id="element-201" data-mp="2wxqf6edmwmjh">
      <div className="mx-auto grid w-full max-w-3xl grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4" data-id="element-202" data-mp="2wvdwfz01y85d">
        {stats.map(stat => <div key={stat.label} className="rounded-2xl border border-navy/5 bg-white px-3 py-5 text-center shadow-sm" data-id="element-203" data-mp="2nwinif5mijyd">
            <p className="font-display text-[30px] font-black leading-none tracking-tight text-teal-600 sm:text-4xl" data-id="element-204" data-mp="2961fgcyhgvsi">
              {stat.value}
            </p>
            <p className="mt-2 text-[11px] font-semibold uppercase leading-snug tracking-wide text-navy/60 sm:text-xs" data-id="element-205" data-mp="208io6qu8xl86">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}